import { useCallback, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { readLocal, UI_KEYS, writeLocal } from '../../lib/storage';
import { findNavItem } from '../../routes/navigation';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { GlobalFilters } from './GlobalFilters';

export function AppLayout(): JSX.Element {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(() => readLocal(UI_KEYS.sidebarCollapsed) === 'true');

  const toggle = useCallback(() => {
    setCollapsed((current) => {
      const next = !current;
      writeLocal(UI_KEYS.sidebarCollapsed, String(next));
      return next;
    });
  }, []);

  const navItem = findNavItem(location.pathname);

  return (
    <div className="app-shell" data-collapsed={collapsed}>
      <Sidebar collapsed={collapsed} onToggle={toggle} />
      <div className="app-main">
        <a className="skip-link" href="#contenido">
          Saltar al contenido
        </a>
        <Header />
        <main id="contenido" className="page" tabIndex={-1}>
          {navItem?.showFilters === true && <GlobalFilters />}
          <Outlet />
        </main>
      </div>
    </div>
  );
}
